<template>
  <div>
    <div class="project-list m-t-md">
      <table class="table table-hover m-t-sm">
        <sort-by-headers :headers="headers" @triggerSort="pStore.setSortOrder($event.prop, $event.dir)" :notSortable="notSortable"></sort-by-headers>
        <tbody>
          <tr v-for="project in projects" :key="project.id" :style="project.archived ? 'background-color: #FFDFDDFF' : ''">
            <td>
              <router-link v-if="!project.archived" :to="{path: `/task-manager/projects/${project.slug ? project.slug : project.id}`}">
                {{ project.name }}
              </router-link>
              <span v-else style="text-decoration: line-through;">{{ project.name }}</span>
              <br/>
              <small v-if="project.slug">
                <strong>{{ project.slug }}</strong>
              </small>
            </td>
            <td>{{ project.description || '/' }}</td>
            <td>
              <span v-for="(val, i) in project.departments" :key="project.id + '-department-' + i" class="label label-primary m-r-xs m-b-xs display-inline-block">
                {{ val }}
              </span>
            </td>
            <td>{{ project.targetDate | aTime('DD.MM.YYYY') }}</td>
            <td>
              <span v-for="user in project.participants" :key="user.id" class="label m-r-xs m-b-xs m-b-xs display-inline-block">
                {{ user.username }}
              </span>
            </td>
            <td><span class="label label-primary">{{ project.status || '/' }}</span></td>
            <td>
              <span v-for="(tag, i) in project.tags" :key="project.id + '-tag-' + i" class="label label-success m-r-xs m-b-xs display-inline-block">
                {{ tag }}
              </span>
            </td>
            <td><span class="label">{{ project.client ? project.client.name : '/' }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { Browser } from '../../../../mixins/helperMixin'
import SortByHeaders from '../Tasks/SortByHeaders.vue'
import { useProjectStore } from '../../../../stores/ProjectStore'
import { storeToRefs } from 'pinia'

export default {
  setup () {
    const pStore = useProjectStore()
    const { projects } = storeToRefs(pStore)
    return { pStore, projects }
  },
  data () {
    return {
      headers: [
        {
          label: 'Name',
          index: 'name'
        },
        {
          label: 'Description',
          index: 'description'
        },
        {
          label: 'Departments',
          index: 'departments'
        },
        {
          label: 'Deadline',
          index: 'targetDate'
        },
        {
          label: 'Participants',
          index: 'participants'
        },
        {
          label: 'Status',
          index: 'status'
        },
        {
          label: 'Tags',
          index: 'tags'
        },
        {
          label: 'Clients',
          index: 'client'
        }
      ],
      notSortable: ['description', 'participants', 'tags', 'description', 'departments']
    }
  },
  mixins: [Browser],
  components: {
    sortByHeaders: SortByHeaders
  }
}
</script>
<style scoped>
.display-inline-block {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Projects/List.vue